function useGetPlatformInfo() {
    const platform = window?.platform?.toLowerCase();
    const isShellApp = platform === 'android' || platform === 'ios';
    return {
        isShellApp,
    };
}

export default useGetPlatformInfo;
